import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "message-composer" }
const _hoisted_2 = {
  key: 0,
  class: "message-composer__reply-header"
}
const _hoisted_3 = { class: "message-composer__reply-text" }
const _hoisted_4 = { class: "message-composer__reply-actions" }
const _hoisted_5 = {
  key: 1,
  class: "message-composer__subject"
}
const _hoisted_6 = {
  key: 2,
  class: "message-composer__recipients"
}

import type { Conversation, Message } from "@/dtos/Unipile.dto";
import { Icon } from "@iconify/vue";
import { computed, ref } from "vue";
import SocialMessageComposer from "./SocialMessageComposer.vue";

interface Props {
  conversation: Conversation | null;
  replyTo?: Message | null;
  channelStatus?: string;
  isSending?: boolean;
  showAiButtons?: boolean;
  aiButtonsDisabled?: boolean;
  isGeneratingAI?: boolean;
  generatingAction?: string | null;
  contactId?: string;
  icpId?: string;
  icps?: Array<{ id: string; name: string; isDefault?: boolean }>;
  channelName?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageComposer',
  props: {
    conversation: {},
    replyTo: {},
    channelStatus: {},
    isSending: { type: Boolean, default: false },
    showAiButtons: { type: Boolean, default: false },
    aiButtonsDisabled: { type: Boolean, default: false },
    isGeneratingAI: { type: Boolean, default: false },
    generatingAction: {},
    contactId: {},
    icpId: {},
    icps: {},
    channelName: {}
  },
  emits: ["send-message", "cancel-reply", "ai-reply", "ai-followup", "ai-compose"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const socialComposerRef = ref<InstanceType<typeof SocialMessageComposer> | null>(null);

__expose({
  setContent: (content: string) => {
    if (socialComposerRef.value) {
      (socialComposerRef.value as any).setContent?.(content);
    }
  },
  socialComposer: socialComposerRef,
});

const props = __props;

const emit = __emit;

const subject = ref(props.replyTo?.subject ? `Re: ${props.replyTo.subject}` : "");
const cc = ref("");
const bcc = ref("");
const showSubject = ref(true);
const showCcBcc = ref(false);

// Check if this is a social channel (WhatsApp or LinkedIn)
const isSocialChannel = computed(() => {
  const channel = props.conversation?.channel;
  return channel === "whatsapp" || channel === "linkedin";
});

const handleSocialSend = (data: {
  text?: string;
  quote_id?: string;
  attachments?: File[];
  voice_message?: File;
  video_message?: File;
}) => {
  emit("send-message", {
    text: data.text,
    quote_id: data.quote_id,
    attachments: data.attachments,
    voice_message: data.voice_message,
    video_message: data.video_message,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isSocialChannel.value)
      ? (_openBlock(), _createBlock(SocialMessageComposer, {
          key: 0,
          ref_key: "socialComposerRef",
          ref: socialComposerRef,
          conversation: __props.conversation,
          "reply-to": __props.replyTo,
          "channel-status": __props.channelStatus,
          "is-sending": __props.isSending,
          "show-ai-buttons": __props.showAiButtons,
          "ai-buttons-disabled": __props.aiButtonsDisabled,
          "is-generating-a-i": __props.isGeneratingAI,
          "contact-id": __props.contactId,
          "icp-id": __props.icpId,
          icps: __props.icps,
          "generating-action": __props.generatingAction,
          "channel-name": __props.channelName,
          onSendMessage: handleSocialSend,
          onCancelReply: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel-reply'))),
          onAiReply: _cache[1] || (_cache[1] = (payload) => _ctx.$emit('ai-reply', payload)),
          onAiFollowup: _cache[2] || (_cache[2] = (payload) => _ctx.$emit('ai-followup', payload)),
          onAiCompose: _cache[3] || (_cache[3] = (payload) => _ctx.$emit('ai-compose', payload))
        }, null, 8, ["conversation", "reply-to", "channel-status", "is-sending", "show-ai-buttons", "ai-buttons-disabled", "is-generating-a-i", "contact-id", "icp-id", "icps", "generating-action", "channel-name"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.conversation && __props.conversation.channel === 'email')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, "Replying to " + _toDisplayString(__props.conversation.contactName), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Icon), { icon: "mdi:send" }),
                  _createVNode(_unref(Icon), { icon: "mdi:delete-outline" })
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.conversation && __props.conversation.channel === 'email')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((subject).value = $event)),
                  type: "text",
                  placeholder: "Subject",
                  class: "message-composer__subject-input"
                }, null, 512), [
                  [_vModelText, subject.value]
                ]),
                _createElementVNode("button", {
                  class: "message-composer__hide-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showSubject.value = !showSubject.value))
                }, _toDisplayString(showSubject.value ? "Hide" : "Show"), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.conversation && __props.conversation.channel === 'email' && showCcBcc.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((cc).value = $event)),
                  type: "text",
                  placeholder: "CC (comma-separated emails)",
                  class: "message-composer__recipient-input"
                }, null, 512), [
                  [_vModelText, cc.value]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((bcc).value = $event)),
                  type: "text",
                  placeholder: "BCC (comma-separated emails)",
                  class: "message-composer__recipient-input"
                }, null, 512), [
                  [_vModelText, bcc.value]
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})